(function(){
    'use strict';

    angular.module('dataHandlingConditionIfElse', ['ngAnimate', 'journey.canvas.srv'])
        .controller('conditionIfElseCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', conditionIfElseCtrl]);

    function conditionIfElseCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayIfElseConditionOptions = false;
        $scope.createListName = {};
        $scope.createList = {};
        $scope.search = {};

        function resetNode () {
            $scope.displayIfElseConditionOptions = false;
            $scope.errorUrl = false;
        }

        $rootScope.$on('displayConditionIfElseModal', function(evt, conn, showTip) {
            $scope.specificUrlOptions = [
                {
                    value: 'any-tracked-page',
                    message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
                },
                {
                    value: 'is-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
                },
                {
                    value: 'contains-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
                },
                {
                    value: 'doesnotcontain-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
                },
                {
                    value: 'startswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
                },
                {
                    value: 'endswith-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
                },
                {
                    value: 'wildcardmatch-url',
                    message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
                }
            ];

            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;

            $scope.errorUrl  = false;
            $scope.displayForm = true;

            $scope.newlyCreate = true;
            $scope.displayError = false;
            $scope.displaySubMenuIf = false;
            $scope.selectedAction = {};
            $scope.ConnectionsFromLoader = false;
            $scope.displayPlus = [];
            $scope.rectangleCons = [];
            $scope.isElegibleForUpdate = true;
            $scope.modalWindow =  [];
            $scope.hideForLimitCon = [];
            $scope.displayInnerSubMenuIf = [];
            $scope.checkList = [];
            $scope.listTitle = [];
            $scope.linkList = [];

            $scope.append = [];
            $scope.urlError = [];
            $scope.emailList = helpers.jbContainsSendEmail();
            $scope.hasArrow = {};
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayIfElseConditionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.hideWhenLimit = true;

            if($scope.connections.data.conditionGroups) {
                $scope.hideWhenLimit = !($scope.connections.data.conditionGroups.length > 3);

                for(var i = 0; i<$scope.connections.data.conditionGroups.length; i++) {
                    $scope.setActionsModel(i);

                    $scope.checkList[i] = [];
                    $scope.listTitle[i] = [];
                    $scope.modalWindow[i] = [];
                    $scope.append[i] = [];
                    $scope.urlError[i] = [];
                    if($scope.connections.data.conditionGroups[i].length >= 5) {
                        $scope.hideForLimitCon[i] = true;
                    }
                    for(var j=0; j<$scope.connections.data.conditionGroups[i].length; j++){
                        if($scope.connections.data.conditionGroups[i][j].type === 'email' || $scope.connections.data.conditionGroups[i][j].type === 'link') {
                            $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = conn.data.conditionGroups[i][j].selectedOpt[0];

                            (function(i, j, conn) {
                                $timeout(function() {

                                    $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = conn.data.conditionGroups[i][j].selectedOpt[0];
                                    let eId = helpers.getConnectionById (conn.data.conditionGroups[i][j].selectedOpt[0]).data.emailId;
                                    if(!$scope.linkList[i]) {
                                        $scope.linkList[i] = [];
                                    }
                                    canvasService.emailUrls(eId).then((response) => {
                                            response = _.uniq(response.data);
                                            $scope.linkList[i][j] = response;
                                            $scope.linkList[i][j].unshift('Any Link');
                                            $scope.connections.data.conditionGroups[i][j].selectedOpt[1] = conn.data.conditionGroups[i][j].selectedOpt[1];
                                        })
                                        .catch(() => {
                                            $scope.linkList[i][j] = [];
                                            $scope.linkList[i][j].unshift('Any Link');
                                            $scope.connections.data.conditionGroups[i][j].selectedOpt[1] = conn.data.conditionGroups[i][j].selectedOpt[1];
                                        });
                                }, 0);
                            })(i, j, conn);
                        }

                        if($scope.connections.data.conditionGroups[i][j].type === 'list') {
                            var key = $scope.connections.data.conditionGroups[i][j].selectedOpt[0],
                                val = helpers.getContactListItem(key, $scope.contactListData, $scope.segmentData);

                            (function(i, j, val, conn) {
                                $timeout(function() {
                                    $scope.checkList[i][j] = {};
                                    $scope.checkList[i][j][key] = true;
                                    $scope.listTitle[i][j] = val.substring(0, 26) + '...';
                                    $scope.connections.data.conditionGroups[i][j].selectedOpt[0] = conn.data.conditionGroups[i][j].selectedOpt[0];
                                }, 0);
                            })(i, j, val, conn);
                        }
                    }
                }
            }

            $(window).resize(function() {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function()  {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                });
            });
        });

        $rootScope.$on('hideConditionIfElseModal', function() {
            resetNode();
        });

        $scope.contMenu = 0;
        $scope.contMenuInner = 0;

        $scope.stopMenuBroadcast = function() {
            $scope.contMenu = 0;
            $scope.contMenuInner = 0;
        };

        $rootScope.$on('closeInnerMenuIfElse', function() {
            if($scope.displaySubMenuIf) {
                if ($scope.contMenu === 0) {
                    $scope.contMenu = 1;
                }else {
                    $scope.displaySubMenuIf = false;
                    $scope.contMenu = 0;
                }
            }else {
                $scope.contMenu = 0;
            }

            if($scope.displayInnerSubMenuIf && $scope.displayInnerSubMenuIf[0]) {
                if ($scope.contMenuInner === 0) {
                    $scope.contMenuInner = 1;
                }else {
                    $scope.displayInnerSubMenuIf[0] = false;
                    $scope.contMenuInner = 0;
                }
            }else {
                $scope.contMenuInner = 0;
            }
        });

        $rootScope.$on('displayConditionIfElseModalError', function() {
            $scope.errorUrl = true;
        });

        $rootScope.$on('inputErrorsConditionIfElse', function(evt, conditionGroups) {
            angular.extend($scope.connections.data.conditionGroups, conditionGroups);
        });

        $scope.createListClick = (parent, index) => {
            $scope.createList[parent] = {};
            $scope.createList[parent][index] = true;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = (parent, index) => {
            if($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name)
                    .success(({Results}) => {
                        $scope.createListLoader = false;
                        if(Results.length) {
                            let result = Results[0];
                            $scope.contactListData.unshift({
                                ContactCount: 0,
                                ListId: result.ListId,
                                ListName: $scope.createListName.name
                            });

                            $scope.createList[parent][index] = false;
                            $scope.setTitle('', parent, index, result.ListId, $scope.createListName.name);
                            $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                        }
                        else {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        }

                    })
                    .error(() => {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        $scope.createListLoader = false;
                    });
            }
        };

        $scope.goBackList = (parent, index) => {
            $scope.createList[parent][index] = false;
        };

        $scope.calculateModalPos = function(top, left) {
            var currentTopPercent = ((top/window.innerHeight) * 100);
            var currentLeftPercent = ((left/window.innerWidth) * 100);
            var fixedHeight = 400;
            var fixedwidth = 700;

            if((left + 160) > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            $scope.modalTop = ( currentTopPercent + _calculateTopByPos()).toFixed(0) + '%';
            $scope.modalLeft = ( currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';


            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if(totalTop > window.innerHeight) {
                    resTop = -42;
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if($scope.showTip) {
                    resLeft = 22;
                }

                if(totalLeft > window.innerWidth) {
                    resLeft = -45;
                }

                return resLeft;
            }
        };

        $scope.selectCondition = function (groupIndex) {
            $scope.groupIndex = groupIndex;
            $scope.displaySubMenuIf = true;
            $scope.displayInnerSubMenuIf[groupIndex] = true;
        };

        $scope.setActionsModel = function (group) {
            var elIndex = $scope.connections.data.conditionGroups[group].length - 1;

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].condition', function(andOr) {
                if(andOr) {
                    for(var i = 0; i<$scope.connections.data.conditionGroups[group].length; i++){
                        $scope.connections.data.conditionGroups[group][i].condition = andOr;
                    }
                }
            });

            var UpdateFlag = false;
            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedAction', function (newValue, oldValue) {
                if (newValue !== oldValue && newValue !== undefined) {
                    if((newValue === 'hasOpenedEmail' || newValue === 'hasNotOpenedEmail' || newValue === 'hasClickedALink' || newValue === 'hasNotClickedALink') && !$scope.emailList) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.606'));
                        UpdateFlag = true;
                        var selectedOpt = $scope.connections.data.conditionGroups[group][elIndex].selectedOpt;
                        //update connection model
                        $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(oldValue);
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = selectedOpt;
                        $scope.linkList[group][elIndex] = '';
                    }
                    else if(!UpdateFlag) {
                        //update connection model
                        $scope.connections.data.conditionGroups[group][elIndex] = canvasService.getInitIfElseModel(newValue);
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt = [];
                        $scope.checkList[group][elIndex] = {};
                        $scope.listTitle[group][elIndex] = 'Select Option';
                        $scope.linkList[group][elIndex] = '';
                    }
                    else {
                        UpdateFlag = false;
                    }
                }
            });

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt', function (val) {
                if (val) {
                    if (val === 'any-tracked-page') {
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = '';
                        $scope.append[group][elIndex] = false;
                    }
                }
            });

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt[1]', function (url) {
                if ($scope.connections.data.conditionGroups && url && $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url' && $scope.connections.data.conditionGroups[group][elIndex].type !== 'link') {
                    if (url && ($scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url' || $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'wildcardmatch-url') && $scope.connections.data.conditionGroups[group][elIndex].type !== 'link') {
                        var reg;

                        if ($scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url') {
                            reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
                        } else {
                            reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+\/\*$/;
                        }

                        if (!reg.test(url)) {
                            $scope.urlError[group][elIndex] = true;
                        }
                        else {
                            $scope.urlError[group][elIndex] = false;
                        }
                    }
                }
            });

            $scope.$watch('connections.data.conditionGroups[' + group + '][' + elIndex + '].selectedOpt[0]', function (newVal, old) {
                if(old != newVal && newVal) {
                    if($scope.connections.data.conditionGroups && (group > $scope.connections.data.conditionGroups.length -1)) {
                        return;
                    }
                    if($scope.connections.data.conditionGroups[group][elIndex].type == 'link') {
                        let eId = helpers.getConnectionById (newVal).data.emailId;
                        if(!$scope.linkList[group]) {
                            $scope.linkList[group] = [];
                        }
                        canvasService.emailUrls(eId).then((response) => {
                                response = _.uniq(response.data);
                                $scope.linkList[group][elIndex] = response;
                                $scope.linkList[group][elIndex].unshift('Any Link');
                                $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = $scope.linkList[group][elIndex][0];
                            })
                        .catch(() => {
                            $scope.linkList[group][elIndex] = [];
                            $scope.linkList[group][elIndex].unshift('Any Link');
                            $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = $scope.linkList[group][elIndex][0];
                        });
                    }


                    if($scope.connections.data.conditionGroups &&
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt &&
                        ($scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'any-tracked-page' ||
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'is-url' ||
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'contains-url' ||
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'doesnotcontain-url' ||
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'startswith-url' ||
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'endswith-url' ||
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[0] === 'wildcardmatch-url')) {
                        $scope.append[group][elIndex] = false;
                        $scope.urlError[group][elIndex] = false;
                        $scope.connections.data.conditionGroups[group][elIndex].selectedOpt[1] = '';
                    }
                }
            });
        };

        $scope.$on('selectedOption', function (event, option, elId) {
            if($scope.connections.id != elId) {
                return false;
            }

            var opts = option.split(':'),
                type = opts[0],
                val = opts[1],
                group,
                currentLength;

            if((val === 'hasOpenedEmail' || val === 'hasNotOpenedEmail' || val === 'hasClickedALink' || val === 'hasNotClickedALink') && !$scope.emailList) {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.606'));
                return false;
            }

            if ($scope.groupIndex > -1) {
                group = $scope.groupIndex;
                $scope.hideForLimitCon[group] = false;
            } else {
                group = 0;
                $scope.connections.data.conditionGroups = [];
                $scope.connections.data.conditionGroups[group] = [];
                $scope.listTitle = [];
                $scope.modalWindow =  [];
                $scope.hideForLimitCon = [];
                $scope.checkList = [];
                $scope.append = [];
                $scope.urlError = [];
            }

            if(typeof $scope.listTitle[group] === 'undefined'){
                $scope.listTitle[group] = [];
                $scope.modalWindow[group] = [];
                $scope.checkList[group] = [];
                $scope.append[group] = [];
                $scope.urlError[group] = [];
            }

            $scope.connections.data.additionals.showForNewGroup[group] = false;

            currentLength = $scope.connections.data.conditionGroups[group].length;
            $scope.connections.data.conditionGroups[group][currentLength] = canvasService.getInitIfElseModel(val);
            $scope.connections.data.actionsList = canvasService.getActionIfElseList(type);

            $scope.setActionsModel(group);

            $scope.displaySubMenuIf = false;
            $scope.displayInnerSubMenuIf = [];
            $scope.connections.data.additionals.initialCondition = false;

            $scope.listTitle[group][currentLength] = $scope.translate('canvas.condition.ifElse.selectOption');
            $scope.modalWindow[group][currentLength] = false;

            if(val !== 'inList' && val !== 'notInList' && val !== 'inSegment' && val !== 'notInSegment') {
                $scope.connections.data.conditionGroups[group][currentLength].selectedOpt = [];
            }

            if(currentLength>1){
                var previousCon = $scope.connections.data.conditionGroups[group][currentLength-1].condition;
                $scope.connections.data.conditionGroups[group][currentLength].condition = previousCon;
            }

            if(currentLength === 4) {
                $scope.hideForLimitCon[group] = true;
            }
        });

        $scope.setGroupWatcher = function(group) {
            $scope.$watch('connections.data.selectedGroupConditions[' + group + ']', function(andOr) {
                if(andOr) {
                    for(var i = 0; i<$scope.connections.data.selectedGroupConditions.length; i++){
                        $scope.connections.data.selectedGroupConditions[i] = andOr;
                    }
                }
            });
        };

        $scope.addNewConditionGroup = function () {
            if ($scope.connections.data.conditionGroups !== undefined) {
                var groupsLength = $scope.connections.data.conditionGroups.length;
                if ($scope.connections.data.conditionGroups[groupsLength - 1].length < 1) {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.608'));
                } else {
                    $scope.connections.data.selectedGroupConditions[groupsLength] = 'and';
                    $scope.connections.data.conditionGroups[groupsLength] = [];
                    $scope.hideForLimitCon[groupsLength] = true;
                    $scope.connections.data.additionals.showForNewGroup[groupsLength] = true;

                    if(groupsLength > 1){
                        var prevCon = $scope.connections.data.selectedGroupConditions[groupsLength - 1];
                        $scope.connections.data.selectedGroupConditions[groupsLength] = prevCon;
                    }

                    if(groupsLength >= 3){
                        $scope.hideWhenLimit = false;
                    }
                    $scope.setGroupWatcher(groupsLength);
                }
            } else {
                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.608'));
            }
        };

        $scope.removeGroupCondition = function (childIndex, parentIndex) {
            $scope.connections.data.conditionGroups[parentIndex].splice(childIndex, 1);
            $scope.hideForLimitCon[parentIndex] = false;
        };

        $scope.deleteGroup = function (group) {
            $scope.connections.data.conditionGroups.splice(group, 1);
            $scope.hideWhenLimit = true;
        };

        $scope.displayModal = function(pidx, idx) {
            var name = pidx + '' + idx;
            $scope.contactListData = $rootScope.contactListData;

            if(!$scope.bindArray) {
                $scope.bindArray = [name];
                $scope.setScrollLogic(name);
                $scope.setScrollSegmentLogic(name);
            }else {
                if($scope.bindArray.indexOf(name) === -1) {
                    $scope.setScrollLogic(name);
                    $scope.setScrollSegmentLogic(name);
                    $scope.bindArray.push(name)
                }
            }

            $scope.modalWindow[pidx][idx] = true;
        };

        $scope.hideModal = function(pidx, idx, clearList) {
            if(clearList) {
                $scope.checkList[pidx][idx] = {};
                $scope.connections.data.conditionGroups[pidx][idx].selectedOpt[0] = '';
                $scope.listTitle[pidx][idx] = $scope.translate('canvas.condition.ifElse.selectOption');
            }
            $scope.modalWindow[pidx][idx] = false;
            $scope.search.list = "";
            $scope.contactListData = $rootScope.contactListData;
        };

        $scope.setTitle = function(evt, parent, index, key, val) {
            if(key && val) {
                if($scope.connections.isDummy) {
                    delete $scope.connections.isDummy;
                }

                $scope.checkList[parent][index] = {};
                $scope.checkList[parent][index][key] = true;
                $scope.connections.data.conditionGroups[parent][index].selectedOpt[0] = key;
                if(val.length > 26) {
                    val = val.substring(0,26) + '...';
                }
                $scope.listTitle[parent][index] = val;
            }
        };

        $scope.parseDescription = function(desc) {
            if (!desc){
                return $scope.translate('commons.enterDetails');
            }

            return desc;
        };

        $scope.setScrollLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('listContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getContactList($rootScope.contactListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.contactListOffset++;
                                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                                    $scope.contactListData = $rootScope.contactListData;
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.search =  (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                        $scope.contactListData = [];
                        if($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                            $scope.connections.data.selectedList.forEach((item) => {
                                for (let i = 0; i < $rootScope.contactListData.length; i++) {
                                    if ($rootScope.contactListData[i].ListId === item) {
                                        $scope.contactListData.push($rootScope.contactListData[i]);
                                        break;
                                    }
                                }
                            });
                        }

                        $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.contactListData = $rootScope.contactListData;
            }
        };

        $scope.setScrollSegmentLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('segmentContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getSegments($rootScope.segmentListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.segmentListOffset++;
                                    $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(data.Results), 'SegmentId');
                                    $scope.segmentData = $rootScope.segmentData;
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.searchSegment =  (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactSegment(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(res.data.Results), 'ListId');
                        $scope.segmentData = [];
                        if($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                            $scope.connections.data.selectedList.forEach((item) => {
                                for (let i = 0; i < $rootScope.segmentData.length; i++) {
                                    if ($rootScope.segmentData[i].ListId === item) {
                                        $scope.segmentData.push($rootScope.segmentData[i]);
                                        break;
                                    }
                                }
                            });
                        }

                        $scope.segmentData = $scope.segmentData.concat(res.data.Results);
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.segmentData = $rootScope.segmentData;
            }
        };

        //Cancel Button
        $scope.cancel = function () {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the if/else node
                $rootScope.$broadcast('deleteIfElseNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            var conditionsGroup = $scope.connections.data.conditionGroups;
            for (var grp = 0; grp < conditionsGroup.length; grp++) {
                for (var con = 0; con < conditionsGroup[grp].length; con++) {
                    $scope.connections.data.conditionGroups[grp][con].hasError = false;
                }
            }
            $rootScope.$emit('saveConditionIfElse' + $scope.connections.id, $scope.connections);
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/conditionIfElseController.js